import { useEffect, useRef } from "react";

/**
 * Reusable AdSense responsive display ad.
 * Requires the AdSense script loaded in index.html.
 * `slot` is the AdSense ad-slot ID. Leave undefined to rely on Auto Ads only.
 */
export default function AdBanner({ slot, className = "", style, format = "auto", testId }) {
  const ref = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    pushed.current = true;
    try {
      // eslint-disable-next-line no-undef
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      /* AdSense script may still be loading; safe to ignore */
    }
  }, []);

  return (
    <div className={`w-full flex justify-center my-8 ${className}`} data-testid={testId || "ad-banner"}>
      <ins
        ref={ref}
        className="adsbygoogle"
        style={{ display: "block", width: "100%", minHeight: 90, ...style }}
        data-ad-client="ca-pub-3943017937793943"
        data-ad-slot={slot || ""}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}
